<!-- =========================================================================================
  File Name: PackageEdit.vue
  Description: Package Edit Page
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="Package Not Found" :active.sync="package_not_found">
      <span>Package with id: {{ $route.params.packageId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'package-list'}" class="text-inherit underline">All Packages</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="package_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          
          <vs-tab label="Detalhes" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <package-edit-tab-information class="mt-4" :data="package_data" />
            </div>
          </vs-tab>
         
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>

import PackageEditTabInformation from "./PackageEditTabInformation.vue"


// Store Module
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'

export default {
  components: {
    PackageEditTabInformation,
  },
  data() {
    return {
      package_data: null,
      package_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
    }
  },
  watch: {
    activeTab() {
      this.fetch_package_data(this.$route.params.packageId)
    }
  },
  methods: {
    fetch_package_data(packageId) {
      this.package_data  = this.$store.getters['packageManagement/packageByID'](packageId)
      //console.log(this.package_data);
    }
  },
  created() {

    if(!modulePackageManagement.isRegistered) {
      this.$store.registerModule('packageManagement', modulePackageManagement)
      modulePackageManagement.isRegistered = true
    }
    this.fetch_package_data(this.$route.params.packageId)
  }
}

</script>
